import { inject, NgModule } from "@angular/core";
import { Router, RouterModule, Routes } from "@angular/router";
import { LandingComponent } from "./landing/landing.component";

const routes: Routes = [
  { path: "home", component: LandingComponent },
  {
    path: "docs",
    loadChildren: () =>
      import("./docs/docs.module").then((module) => module.DocsModule),
  },
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "unauthorized/:unauthorizedType",
    redirectTo: ({ params }) =>
      inject(Router).createUrlTree(["/home"], {
        queryParams: { accessDenied: params["unauthorizedType"] },
      }),
    pathMatch: "full",
  },
  {
    path: "studio",
    loadChildren: () =>
      import("./main-container/main-container.module").then(
        (m) => m.MainContainerModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
